(ns pfo.widget.select (:require [reagent.core :as reagent :refer [atom]]
                                [promesa.core :as p]
                                [pfo.api :refer [process-error]]
                                [pfo.form :refer [set-selected unselect-if-no-value]]
                                [pfo.util :as util]))
    
(defn nested-select [selected-item {:keys [initial-id
                                           top-id
                                           limit-ancestors
                                           clear-trigger]
                                    :as options}]
  (let [initial-id (util/somestr-to-int initial-id)
        top-id (util/somestr-to-int top-id)
        item-ancestors (atom [])
        children (atom [])
        load-items (fn [item-id]
                     (reset! selected-item item-id)
                     (->>
                       ((:children-loader options) item-id)
                       (p/map (fn [response] (reset! children response)))
                       (process-error))
                     (if item-id
                       (->> ((:ancestors-loader options) item-id) (p/map #(reset! item-ancestors %))
                            (process-error))
                       (reset! item-ancestors [])))
        sizer (or (:sizer options) (fn [_] 1))]
    
    (when clear-trigger 
      (add-watch clear-trigger :clear-nested-select (fn [_ _ _ new-value]
                                                      (load-items (if limit-ancestors top-id nil)))))
    
    (load-items initial-id)
    (fn [_ {:keys [child-filter-pred header-extra extra-option collapsed green-box clear-trigger mobile]}]
      (let [child-filter-pred (or child-filter-pred identity)
            clear-fn (util/handler #(load-items (if limit-ancestors top-id nil)))]
        [:div.nested-select
         [:h3.u-padding-top.u-border-top--light-green.u-cursor--pointer.u-flex.o-collapsable {:class (when collapsed "is-collapsed")}
          [:span {:on-click clear-fn}
           (:label options)]
          (when (:collapse-fn options)
            [:a.o-collapsable__expander {:on-click (util/handler (:collapse-fn options))}])]
         [:span.u-font-size--smaller.u-color--secondary
          (doall
            (interpose " / "
              (for [ancestor (if (and top-id limit-ancestors)
                               (drop-while (fn [ancestor] (not= top-id (:id ancestor))) @item-ancestors)
                               @item-ancestors)]
                [:span.u-cursor--pointer {:on-click (util/handler #(load-items (:id ancestor)))
                                          :key (:id ancestor)} (util/add-inactive-to-name ancestor)])))]
         [:p.u-font-size--smaller.u-flex.u-flex--justify-content-space-between
          (when (:clear options)
            [:a {:href "#"
                 :class (when-not @selected-item :u-disable)
                 :on-click clear-fn} "CLEAR"])
          (when extra-option extra-option)]
         (when (not-empty @children)
           (let [size (sizer @children)]
             [:div.o-collapsable {:class (util/classes
                                           (when green-box "u-border--green-rounded")
                                           (when collapsed "is-collapsed__partial"))}
              [:select.u-hide-scrollbar {:on-change (fn [ev] (load-items (-> ev .-target .-value)) (.preventDefault ev))
                        :size (+ 1 (count @children))
                        :ref (unselect-if-no-value nil (if mobile 0 -1))}

               (when (or (= size 1) mobile)
                 [:option {:value nil :selected "selected" :disabled :disabled} "Choose"])
               (doall (for [child (filter #(child-filter-pred %) @children)]
                        [:option (set-selected @selected-item (:id child) {:key (:id child) :value (:id child)}) (util/add-inactive-to-name child)]))]]))]))))

(defn default-select-sizer [items]
  (+ 1 (min (count items) 9)))
